// @flow
export { default } from './SaveProductCard';



// WEBPACK FOOTER //
// ./src/components/saves/SaveProductCard/index.js